import React, {useState} from 'react';
import Container from 'react-bootstrap/Container';
import { GiDivergence } from 'react-icons/gi';
import { Colors, Spacing, Typography } from '_styles';


const TouchableHighlight = (props) => {
    
    const [toggle, setToggle] = useState(false);        // toggle on hover

    return (
        <div style={{opacity:toggle? 0.6 : 1.0, height:props.height, width:props.width, cursor:'pointer' }} {...props} onClick={props.onClick} onMouseEnter={()=>{setToggle(true)}} onMouseLeave={()=>{setToggle(false)}}>
            {props.children}
        </div>
    );
}

export default TouchableHighlight;